import $ from 'jquery';

// See https://wiki.archlinux.org/index.php/KEYMAP
const language_presets = {
  de: {
    keyboard_layout: "de",
    timezone: "Europe/Berlin",
    language: "de_DE.utf8"
  },
  at: {
    keyboard_layout: "de",
    timezone: "Europe/Vienna",
    language: "de_AT.utf8"
  },
  ch_de: {
    keyboard_layout: "de",
    timezone: "Europe/Zurich",
    language: "de_CH.utf8"
  },
  ch_fr: {
    keyboard_layout: "fr",
    timezone: "Europe/Zurich",
    language: "fr_CH.utf8"
  },
  fr: {
    keyboard_layout: "fr",
    timezone: "Europe/Paris",
    language: "fr_FR.utf8"
  },
  us: {
    keyboard_layout: "us",
    timezone: "Europe/Berlin",
    language: "en_US.utf8"
  },
  se: {
    keyboard_layout: "se",
    timezone: "Europe/Stockholm",
    language: "sv_SE.utf8"
  },
  dk: {
    keyboard_layout: "dk",
    timezone: "Europe/Copenhagen",
    language: "da_DK.utf8"
  }
};

$(() => {
  $('body.resource_system_config .preset_flag').click(e => {
    const lang = $(e.target).data('target');
    $.each(language_presets[lang], (k, v) =>
      $(e.target).closest('form').find('#system_config_' + k).val(v));
  });
});
